import { Link } from 'react-router-dom';
import styled, { withTheme } from 'styled-components'
import config from 'src/config/config';
import { theme } from 'styled-tools';
import { withAppContext } from 'src/store/initAppContext';
import { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import PlaceholderImage from 'src/components/Placeholder';


interface BonusProps {
    bonusImage: any,
    bonusTitle: any,
    bonusUUID: any,
    imageId: number,
    theme: any
}

const BonusSlider = (props: BonusProps) => {
    const [imageName, setImageName] = useState()
    const { theme } = props

    useEffect(() => {
        switch (props.imageId) {
            case 1:
                setImageName(theme.image.sigupBonusSlide)
                break;
            case 2:
                setImageName(theme.image.welcomeBonusSlide)
                break;
            case 3:
                setImageName(theme.image.refillBonusSlide)
                break;
            case 4:
                setImageName(theme.image.referalBonusSlide)
                break;
            case 5:
                setImageName(theme.image.cashbackBonusSlide)
                break;
            case 6:
                setImageName(theme.image.lossBackBonusSlide)
                break;
            default:
        }
    }, [])

    return (
        <>
            <BonusConatinerWrap>
                <Link to={props.bonusUUID}>
                   <LazyLoadImage src={`${config.imageV3Host}/static/cashsite/${imageName}`} alt="Bonus Images"  effect="none" height="100%" width="100%" visibleByDefault={false} placeholder={<PlaceholderImage/>}/>
                </Link>
                <BonusContainerTitle>
                    <p>{props.bonusTitle}</p>
                </BonusContainerTitle>
            </BonusConatinerWrap>
        </>
    )
}

export default withTheme(withAppContext(BonusSlider));

export const BonusConatinerWrap = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`

export const BonusContainerImage: any = styled.img`
    width: 100%;
    object-fit: cover;
    height: 100%;
    object-position: center top;

    @media (min-width: 1500px){
        object-fit: cover;
    }
`
const BonusContainerTitle = styled.div`
    padding: 20px;
    width: 100%;
    align-items: center;
    display: flex;
    justify-content: center;

    & p {
        font-style: normal;
        font-weight: 800;
        font-size: 23px;
        letter-spacing: 0.01em;
        text-transform: capitalize;
        color: #FFFFFF;
        margin: 0px 0px 10px;

        @media (max-width: 1400px) {
            font-weight: 700;
            font-size: 23px;
        }
        @media (max-width: 1280px) {
            font-weight: 700;
            font-size: 13px;
        }
    }
`